import { htmlStringToText } from "../../_src_shared/utils/functions/htmlStringToText";

/**
 * The display title of a loan condition — ONE rule for every surface (the
 * conditions list / checklist, the condition sidebar, the Documents tab chip).
 *
 * 1. The condition's own heading: a promoted AI finding is written as
 *    `<p><strong>{title}</strong></p><p>{body}</p>…` (condition_actions.py), so
 *    a leading bold paragraph is the title.
 * 2. Otherwise the document type it asks for, bare ("Insurance Binder") — never
 *    prefixed with "Missing Document:" (Request Board REQ-112).
 * 3. Otherwise the condition text itself.
 */
export const conditionHeading = (htmlString) => {
  if (!htmlString) return "";
  try {
    const doc = new DOMParser().parseFromString(htmlString, "text/html");
    const first = doc.body.firstElementChild;
    if (!first) return "";
    const strong = first.querySelector("strong, b");
    const firstText = first.textContent?.trim() || "";
    // Only a paragraph that is entirely bold counts as a heading.
    if (strong && firstText && strong.textContent?.trim() === firstText) return firstText;
    if (/^H[1-6]$/.test(first.tagName) && firstText) return firstText;
  } catch {
    return "";
  }
  return "";
};

export const conditionTitle = (c, fallback = "Untitled condition") =>
  conditionHeading(c?.htmlString) ||
  c?.docType ||
  htmlStringToText(c?.htmlString || "") ||
  fallback;
